import * as GoodsBlocks from './blocks'
import { addPortNode } from '@/port'
import { bookGoodsModelProvider, getBookGoodsModel } from './model'
import { defineClassComponent } from '@/hooks'
import { h, onBeforeUnmount, ref } from '@vue/composition-api'
import { submit } from '@/utils'

/**
 * 显示 SKU 选择器。
 */
export async function showSkuPicker(payload: {
  goodsId: string
  isGroupBuying?: boolean
  groupBuyingOrderId?: string
}) {
  await submit(async $ => {
    $.start()
    const goodsData = (await getBookGoodsModel(payload.goodsId))!
    if (goodsData.isOff) {
      goodsData.$destroy()
      return $.fail('商品已下架')
    }
    const SkuPicker = defineClassComponent(
      ({ ctx }) =>
        class {
          constructor() {
            bookGoodsModelProvider.provide(this.goodsData)

            onBeforeUnmount(() => {
              goodsData.$destroy()
              destroyPort()
            })
          }

          goodsData = ref(goodsData)

          render = () =>
            h(GoodsBlocks.BookGoodsActions, {
              props: {
                isShowSkuPicker: true,
                isShowSkuPickerFromGroupBuying: !!payload.isGroupBuying,
                groupBuyingOrderId: payload.groupBuyingOrderId,
              },
              on: {
                closeSkuPicker: () => {
                  ctx.$destroy()
                },
              },
            })
        },
    )
    const destroyPort = addPortNode(h(SkuPicker))
  })
}
